import wrapTopicThreadAnchor from '@lib/richTextProcessor/wrapTopicThreadAnchor';
import wrapPeerTitle from '@components/wrappers/peerTitle';

export default async function wrapTopicNameButton(
  options: {
    lastMsgId?: number,
    noAvatarAndLink?: boolean
  } & Pick<Parameters<typeof wrapPeerTitle>[0], 'peerId' | 'threadId' | 'wrapOptions' | 'withIcons' | 'dialog'>
) {
  const {peerId, threadId, lastMsgId} = options;

  const loadPromise: Promise<any> = Promise.resolve();
  let element: HTMLElement;

  if(options.noAvatarAndLink) {
    element = document.createElement('span');
  } else {
    element = wrapTopicThreadAnchor({peerId, threadId, lastMsgId});
  }

  element.classList.add('topic-name', 'topic-name-button');
  // if(threadId) {
  //   const topic = await rootScope.managers.dialogsStorage.getForumTopic(peerId, threadId);
  //   if(!topic) {
  //     element.append(i18n('Loading'));
  //     loadPromise = rootScope.managers.dialogsStorage.getForumTopicById(peerId, threadId)
  //   }
  // } else {
  element.append(await wrapPeerTitle(options));
  // }

  return {
    cached: true,
    element,
    loadPromise
  };
}
